<template>
  <div class="">
    <div class="head-title">线索来源管理</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            录入来源线索时的选项管理，例如：广告、网站、公众号、活动现场等。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <el-input
            clearable
            class="shij"
            v-model="form.name"
            placeholder="线索来源"
          >
          </el-input>
          <el-button
            class="shij"
            icon="el-icon-plus"
            @click="numoo()"
            type="primary"
          >
            确认添加
          </el-button>
        </div>
        <div class="nav-r">
          <el-input
            clearable
            style="width: 35.0rem; "
            placeholder="请输入名称搜索"
            prefix-icon="el-icon-search"
            v-model="input2"
            @change="rune()"
          ><el-button slot="append" @click="rune()" type="primary"
            >查询</el-button
          >
          </el-input>

        </div>
      </nav>
      <el-table
        :data="tableData"
        border
        v-loading="tableLoading"
        style="width: 100%; margin-top: 2.0rem; overflow: auto;"
      >
      <!--- v-infinite-scroll="load"-->
      <!---height="calc(100vh - 4.9rem)-->
        <el-table-column min-width="30.0rem" label="名称">
          <template slot-scope="{ row }">
            <template v-if="row.edit">
              <el-input
                clearable
                v-model="row.name"
                size="small"
                class="edit-input"
                placeholder="请输入名称"
              ></el-input>
              <el-button
                class="cancel-btn"
                size="small"
                icon="el-icon-refresh"
                style="background-color:#eeeeee"
                @click="cancelEdit(row)"
              >
                取消
              </el-button>
            </template>
            <span v-else>{{ row.name }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="phone"
          label="添加人手机"
          style="width: 20%"
        ></el-table-column> -->
        <el-table-column prop="createtime" label="添加时间"></el-table-column>
        <el-table-column prop="updatetime" label="修改时间"></el-table-column>
        <el-table-column label="操作" fixed="right" width="300">
          <template slot-scope="scope">
            <div v-if="scope.row.phone != '系统管理员'">
              <el-button
                v-if="scope.row.edit"
                type="text"
                size="mini"
                @click="confirmEdit(scope.row)"
              >
                确定
              </el-button>
              <el-button
                v-else
                size="mini"
                @click="onEdit(scope.row)"
                type="text"
                >编辑</el-button
              >
              <el-button
                size="mini"
                @click="handleClick(scope.row.id)"
                type="text"
                style="color:#f00000 !important"
              >
                删除
              </el-button>
            </div>
            <div v-else-if="scope.row.phone == '系统管理员'">
              <el-button type="primary" disabled>编辑</el-button>
              <el-button type="danger" disabled> 移除 </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
          <pagination
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            :page-sizes="[10,20,50,100]"
            @pagination="userTable"
          />
        </div>
    </div>
    <el-dialog title="添加" center :visible.sync="onSubmit" width="30%">
      <el-form ref="form" :model="form" label-width="8.0rem">
        <el-form-item label="添加" prop="name">
          <el-input clearable v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit = false">取 消</el-button>
        <el-button type="primary" @click="numoo()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑" center :visible.sync="onSubmitn" width="30%">
      <el-form ref="form" :model="form" label-width="8.0rem">
        <el-form-item label="名称" prop="none">
          <el-input clearable v-model="bianjile">{{ bianjile }}</el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitn = false">取 消</el-button>
        <el-button type="primary" @click="numoon()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
export default {
  name: "monitoring",
  data() {
    return {
      tableData: [
      ],
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        none: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      total: 0,
      pageSize: "",
      listQuery: {
        page: 1,
        limit: 20,
      },
      tableLoading: true
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
  },
  methods: {
    //  页数
    /*
    load() {
      setTimeout(() => {
        this.yeshu += 1;
        this.axios
          .post(
            "/crm/Source/getSourceList",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              phone: this.tooken.phone,
              page: this.yeshu,
              name: this.input2,
              number_page:this.listQuery.limit
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }

            res.data.data.forEach((item) => {
              item.edit = false;
              this.tableData.push(item);
            });

          })
          .catch(function (err) {});
      }, 2000);
    },*/
    userTable() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Source/getSourceList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            name: this.input2,
            number_page:this.listQuery.limit
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }

          res.data.data.forEach((i) => {
            i.edit = false;
          });
          this.tableLoading = false;
          this.tableData = res.data.data;
          this.total =  res.data.count;
        })

        .catch(function (err) {});
    },
    rune() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Source/getSourceList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }

          res.data.data.forEach((i) => {
            i.edit = false;
          });
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    tianjia() {
      this.yeshu = 1;
      this.axios
        .post(
          "/home/sessionUser/ifRemoveUserTwo",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },

    handleSelectionChange(val) {
      this.yeshu = 1;
      this.multipleSelection = val;
    },
    bianji(e, o) {
      this.yeshu = 1;
      this.ele = e;
      this.bianjile = o;
    },
    onEdit(row) {
      row.originalName = row.name;
      row.edit = true;
    },
    cancelEdit(row) {
      row.name = row.originalName;
      row.edit = false;
    },
    confirmEdit(row) {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Source/editSource",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            account_id: this.tooken.id,
            name: row.name,
            id: row.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            // this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 修改
    numoon() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Source/editSource",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            account_id: this.tooken.id,
            name: this.bianjile,
            id: this.ele,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            // this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 添加
    numoo() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Source/addSource",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.form.name,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.form.name=""
          } else if (res.data.code == 0) {
            // this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 移除
    handleClick(e, o) {
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/Source/delSource",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
            type: "info",
          });
        });
    },

  },
};
</script>
<style  lang="scss" scoped>
::v-deep .el-table__body tr.current-row > td {
  background-color: rgb(185, 234, 250);
}
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgb(185, 234, 250);
}
::v-deep
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped.current-row
  td {
  background-color: rgb(185, 234, 250);
}
.hello {
  width: 100%;
  height: 100%;
  padding: 2.0rem;
  overflow: hidden;
  overflow-y: auto;
  background-color: #ffffff;
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
}
.shij {
  display: inline-block;
}
.shij:nth-child(1) {
  // margin-right: 2.4rem;
  width: 27.0rem;
}
.navbar {
  display: flex;
  justify-content: space-between;
}
.nav-l {
  display: flex;
}
.edit-input {
  padding-right: 10.0rem;
}
.cancel-btn {
  position: absolute;
  right: 1.5rem;
  top: 1.0rem;
}
.el-button--text{padding-left:.0rem !important;}
</style>
